import { render, staticRenderFns } from "./TeachingDynamics.vue?vue&type=template&id=3bbb6e95&scoped=true"
import script from "./TeachingDynamics.vue?vue&type=script&lang=js"
export * from "./TeachingDynamics.vue?vue&type=script&lang=js"
import style0 from "./TeachingDynamics.vue?vue&type=style&index=0&id=3bbb6e95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbb6e95",
  null
  
)

export default component.exports